import React from "react";
export default function DaggerSymbol() {
    return React.createElement(React.Fragment, null, "\u2020\uFE0E");
}
export function DoubleDaggerSymbol() {
    return React.createElement(React.Fragment, null, "\u2021\uFE0E");
}
//# sourceMappingURL=DaggerSymbol.js.map